import { loadAuth } from "../libs/authMgmt";

export const homeNav = [
  {
    link: "/dashboard",
    label: "Dashboard",
    icon: "Home",
  },
  // {
  //   link: "/demo-dashboard",
  //   label: "DashboardV2",
  //   icon: "Gauge",
  // },
  {
    link: "/ai",
    label: "AI Chat",
    icon: "Sparkles",
  },
];

export const productMgntNav =
  loadAuth("role") === "admin"
    ? [
        {
          link: "/pos",
          label: "Sales",
          icon: "BriefcaseBusiness",
        },
        {
          link: "/inventory",
          label: "Inventory",
          icon: "Box",
        },
        {
          link: "/kitchen",
          label: "Kitchen View",
          icon: "CookingPot",
        }
      ]
    : loadAuth("role") === "cashier"
    ? [
        {
          link: "/pos",
          label: "Sales",
          icon: "BriefcaseBusiness",
        },
      ]
    : loadAuth("role") === "inventory"
    ? [
        {
          link: "/inventory",
          label: "Inventory",
          icon: "Box",
        },
      ]
    : loadAuth("role") === "kitchen"
    ? [
        {
          link: "/kitchen",
          label: "Kitchen View",
          icon: "CookingPot",
        },
      ] : [];

export const accountNav = [
  {
    link: "/user-roles",
    label: "User & Roles",
    icon: "User",
  },
  {
    link: "/my-shop",
    label: "My Shop",
    icon: "Store",
  },
  {
    link: "/manage-menu",
    label: "Manage E-Menu",
    icon: "Pizza",
  },
  {
    link: "/manage-expenses",
    label: "Manage Expenses",
    icon: "BadgeDollarSign",
  },
  {
    link: "/sales-history",
    label: "Sales History",
    icon: "History",
  },
];

const computeSystemNav = () => {
  if (loadAuth("role") === "admin") {
    return [
      {
        link: "/settings",
        label: "Settings",
        icon: "Cog",
      },
      // {
      //   link: "/pay-settings",
      //   label: "Payment Settings",
      //   icon: "HandCoins",
      // },
      {
        link: "/logout",
        label: "Logout",
        icon: "LogOut",
      },
    ];
  } else {
    return [
      {
        link: "/logout",
        label: "Logout",
        icon: "LogOut",
      },
    ];
  }
};
export const systemNav = computeSystemNav();
